'use client'

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './DestinationCarouselSwiper.scss';
import { CarouselItem } from '@/src/types/dictionaries';
import { useAOS } from '@/src/lib/hooks/useAOS';
import Link from 'next/link';
import Image from 'next/image';

interface Props {
  title?: string;
  subtitle?: string;
  data?: CarouselItem[];
}

const DestinationCarouselSwiper: React.FC<Props> = ({
  title = 'Our Favorite Escapes',
  subtitle = 'DESTINATIONS',
  data = []
}) => {
  useAOS()

  return (
    <section
      className={`destination-carousel-section`}
    >
      <div className="destination-carousel-header" data-aos="zoom-in">
        <span className="carousel-subtitle" data-aos="fade-down">{subtitle}</span>
        <h2 className="carousel-title" data-aos="fade-up">{title}</h2>
      </div>

      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        }}
        navigation
        pagination={{ clickable: true }}
        className="carousel-swiper"
      >
        {data.map((item, index) => (
          <SwiperSlide key={index}>
            <Link
              href={item.link}
              className="carousel-card"
              aria-label={`Explore ${item.name}`}
            >
              <Image
                src={item.imageUrl}
                alt={item.name}
                height={300}
                width={400}
                data-aos="zoom-in"
              />
              <div className="carousel-card-overlay" data-aos="fade-up">
                <h3>{item.name}</h3>
                <p>{item.description}</p>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default DestinationCarouselSwiper;